import styled from 'styled-components';

// Material-UI
import MuiDivider from '@material-ui/core/Divider';

// *************************************
// STYLED COMPONENTS                           
// *************************************

export const StyledDivider = styled(MuiDivider)`
  &.MuiDivider-root {
    background-color: ${ (props) => props.theme.colors.greyLight};
  }
`;
